import dt from 'dayjs'
import * as lib from '../lib'
import { IFetchItems, IFetchOfferSpend, IOfferSpend } from '../types'

export const listOfferSpend = async (
	filter: ReturnType<typeof lib.filterSetup>,
	sort: ReturnType<typeof lib.sortSetup>,
	skip: ReturnType<typeof lib.skipSetup>,
	take: ReturnType<typeof lib.takeSetup>,
	signal: AbortSignal,
	token?: string | null,
): Promise<IFetchItems<IOfferSpend>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {
		f: filter,
		s: sort,
		skip,
		take
	}
	const uri: string = 'offer/spend'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal,
	}
	const data = await lib.fetching<IFetchItems<IFetchOfferSpend>>(uri, options)

	const rows = data?.items
		?.map((item: IFetchOfferSpend): IOfferSpend => {
			const { at, createdAt, updatedAt, ...row } = item
			const result = {
				...row,
				at: dt.utc(at).utc().toDate(),
				createdAt: dt(createdAt).toDate(),
				updatedAt: dt(updatedAt).toDate(),
				offer: !row?.offer ? null : {
					...row.offer,
					createdAt: dt(row.offer.createdAt).toDate(),
					updatedAt: dt(row.offer.updatedAt).toDate(),
					deletedAt: row.offer.deletedAt ? dt(row.offer.deletedAt).toDate() : null,
					scope: !row.offer?.scope ? null : {
						...row.offer.scope,
						createdAt: dt(row.offer.scope.createdAt).toDate(),
						updatedAt: dt(row.offer.scope.updatedAt).toDate(),
					}
				},
				account: !row?.account ? null : {
					...row.account,
					registeredAt: !!row.account.registeredAt ? dt(row.account.registeredAt).toDate() : null,
					createdAt: dt(row.account.createdAt).toDate(),
					updatedAt: dt(row.account.updatedAt).toDate(),
					deletedAt: !!row.account.deletedAt ? dt(row.account.deletedAt).toDate() : null,
					role: !row.account?.role ? null : {
						...row.account.role,
						createdAt: dt(row.account.role.createdAt).toDate(),
						updatedAt: dt(row.account.role.updatedAt).toDate(),
					},
					auth: !row.account?.auth ? null : {
						...row.account.auth,
						updatedAt: dt(row.account.auth.updatedAt).toDate(),
					}
				},
				scope: null // in order to cast type to IOfferSpend (scope?: IOfferScope | null)
			}
			return result
		})

	return {
		items: rows ?? [],
		total: data?.total ?? 0,
	}
}
